import http from '@/core/http';
import { IJianPaiSCMErrorLogListRes, IJianPaiSCMErrorLogListReq } from './index.type';

/**
 * 获取环境配置 不传 获取所有环境
 */
export function getJianPaiSCMErrorLogList(data: IJianPaiSCMErrorLogListReq) {
  return http.post<IJianPaiSCMErrorLogListRes>({
    data,
    url: '/jianpai-scm/web/v1/scm/error-log-page',
    loading: true,
  });
}
